import { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { AdvancedMarker, Marker, useMap } from "@vis.gl/react-google-maps";
import { MapMarker } from "../../../stores/map/types";

type MarkersProps = {
    useAdvancedMarker?: boolean;
    markers: MapMarker[];
    markerImage?: string;
    onMapLoad?: (map: google.maps.Map) => void;
}

const Markers = observer((props: MarkersProps) => {
    const { markers, onMapLoad, useAdvancedMarker = false, markerImage } = props;

    const map = useMap();

    useEffect(() => {
        if (map && onMapLoad) {
            onMapLoad(map)
        }
    }, [markers]);

    if (!markers) {
        return null;
    }

    return (
        <>
            {markers.map((x, ix) =>
                useAdvancedMarker
                    ? <AdvancedMarker
                        key={ix}
                        position={x.position}
                        draggable={false}
                        onClick={x.onClick}
                        title={x.title}>
                        {markerImage && <img src={markerImage} className="map-pin" />}
                    </AdvancedMarker>
                    : <Marker
                        key={ix}
                        position={x.position}
                        icon={markerImage}
                        onClick={x.onClick}
                        title={x.title}
                        draggable={false} />
            )}
        </>
    );
});

export default Markers;